import { render } from "./ProductionlogsList.vue?vue&type=template&id=e2cfbacc&scoped=true"
import script from "./ProductionlogsList.vue?vue&type=script&lang=js"
export * from "./ProductionlogsList.vue?vue&type=script&lang=js"

import "./ProductionlogsList.vue?vue&type=style&index=0&id=e2cfbacc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2cfbacc"]])

export default __exports__